<template>
  <div class="character">
    <h2 class="character__title">
      {{model.title}} <span v-if="model.isRequired" class="color-red">*</span>
    </h2>
    <div class="character__wrap" :class="{'character__wrap--invalid': model.invalid}">
      <div v-show="model.invalid" class="character__popup">
        <p v-for="(error, i) in errors" :key="i">{{error}}</p>
      </div>
      <div @click="toggle" class="character__top">
        <div v-show="!opened" class="character__placeholder">
          1. Выбор характеристики позиции
        </div>
        <button class="btn-toggle character__toggle"
                :class="{'character__toggle--opened': opened}">Toggle</button>
        <button v-tooltip="model.comment" @click.stop
                class="btn-toggle character__info" :disabled="!model.comment">Tooltip</button>
      </div>
      <div v-show="opened" class="character__content">
        <MultiselectControl
          v-model="selected_values"
          placeholder="Выберите единицы измерения"
          :value="selected_values"
          :options="model.values"
          @input="update"
          :multiple="true">
        </MultiselectControl>
      </div>
    </div>
  </div>
</template>

<script>
import MultiselectControl from 'vue-multiselect';

export default {
  name: 'radio',
  components: {
    MultiselectControl,
  },
  props: ['model'],
  data() {
    return {
      value: [],
      checked: [],
      opened: false,
      errors: [],
      selected_values: [],
    };
  },
  mounted() {
    if (this.model.isRequired) {
      this.errors.push('Необходимо заполнить это поле');
    }
  },
  methods: {
    update() {
      const { title, isRequired } = this.model;
      // eslint-disable-next-line camelcase,no-undef
      let { value } = [];

      value = this.selected_values;

      this.errors = [];
      if (isRequired && !value.length) {
        this.errors.push('Необходимо заполнить это поле');
      }
      this.$emit('update', {
        title,
        value,
        model: this.model,
      });
    },
    toggle() {
      this.opened = !this.opened;
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
